import { render, staticRenderFns } from "./HandBlack.vue?vue&type=template&id=67545cb8&scoped=true&"
var script = {}
import style0 from "./HandBlack.vue?vue&type=style&index=0&id=67545cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67545cb8",
  null
  
)

export default component.exports